/*
 *==================================================
 * Licensed Materials - Property of HCL Technologies
 *
 * HCL Commerce
 *
 * (C) Copyright HCL Technologies Limited 2020
 *
 *==================================================
 */
import styled from "styled-components";
import { Menu, MenuItem, Divider } from "@material-ui/core";

export const StyledMenu = styled(Menu)`
  ${({ theme }) => `
    border: 1px solid ${theme.palette.text.disabled};
    box-sizing: border-box;
    box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
    border-radius: 3px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: stretch;

    .MuiList-root {
      padding: 0;
    }
  `}
`;

export const StyledMenuItem = styled(MenuItem)`
  ${({ theme }) => `
    color: ${theme.palette.primary.main};
    font-size: 14px;
    font-weight: 400;
    line-height: 20px;
    letter-spacing: 0.01rem;
    text-align: left;
  `}
`;

export const StyledDivider = styled(Divider)``;
